import React from 'react';
import Link from 'next/link';

import styles from './PostTag.module.scss';
import { ITag } from '../../lib/types';

interface PostTagProps {
  tags: ITag[];
  isV2?: boolean;
}

const PostTag = (props: PostTagProps) => {
  const { tags, isV2 } = props;
  return (
    <div className={isV2 ? styles['post-tag2'] : styles['post-tag']}>
      <strong className="font-weight-bold">Tags : </strong>
      {tags.map((tag) => {
        return (
          <Link key={tag.slug} href={`/tag/[slug]`} as={`/tag/${tag.slug}`}>
            <a className={styles['post-tag--item']} title={tag.name}>
              {tag.name}
            </a>
          </Link>
        );
      })}
    </div>
  );
};

export default PostTag;
